import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type SwapLabelProps = {
    children: ReactNode
    className?: string
}

/**
 * Every label on the original site is rendered twice: the visible copy slides
 * up and out on hover while an identical copy slides in from below.
 * The host element must carry `fw-swap-host`.
 */
export const SwapLabel: FC<SwapLabelProps> = ({ children, className }): ReactNode => {
    return (
        <span className={cn('fw-swap', className)}>
            <span className='fw-swap-in'>
                {children}
            </span>

            <span className='fw-swap-out' aria-hidden='true'>
                {children}
            </span>
        </span>
    )
}
